export default __webpack_public_path__ + "static/01-02-prepare-bring-favourites-47fb0964a7927aecd04fa25494a83de7.mp4";